export enum languages_enum {
  ENGLISH = "en",
  GEORGIAN = "ka",
  RUSSIAN = "ru",
}

export interface globalSliceState {
  language: languages_enum;
}
